<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringpoint.identification' | translate }}</label>
    <input type="text" appInput formControlName="meteringPointIdentification" readonly>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.date.validfrom' | translate }}</label>
    <input type="date" appInput formControlName="validFrom">
  </app-input-group>
</form>
